import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Loader2 } from "lucide-react";
import Brand from "../components/Brand";
import { api } from "../lib/api";

const TOKEN_KEY = "we_staff_token";
const USER_KEY = "we_staff_user";

export default function StaffLogin() {
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/staff/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem(USER_KEY, JSON.stringify(data.user));
      toast.success(`Willkommen, ${data.user.name}!`);
      const redirect = loc.state?.from || "/staff";
      nav(redirect, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login fehlgeschlagen";
      toast.error(typeof msg === "string" ? msg : "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Brand minimal />
      <main className="max-w-md mx-auto px-6 py-20">
        <p className="label-mono text-[color:var(--teal-dark)] mb-2">Mitarbeiter-Login</p>
        <h1 className="font-display text-4xl font-black mb-8">Anmelden</h1>
        <form onSubmit={submit} className="surface p-6 md:p-8 space-y-5">
          <div>
            <label className="label-mono">E-Mail</label>
            <input
              type="email"
              required
              autoFocus
              className="input-clean mt-2"
              data-testid="staff-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="label-mono">Passwort</label>
            <input
              type="password"
              required
              className="input-clean mt-2"
              data-testid="staff-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="staff-login-submit"
            className="btn-primary w-full inline-flex items-center justify-center gap-2"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Anmelden…</> : <><LogIn size={16} /> Anmelden</>}
          </button>
        </form>
        <p className="mt-6 text-xs text-center text-[color:var(--grey)]">
          Passwort vergessen? Frag Christoph — dein Zugang wird zurückgesetzt.
        </p>
      </main>
    </div>
  );
}
